export const Images = {
    pick: 'images/pick_40x40.png',
    miner: 'images/pick_40x40.png',
    offline: 'images/pick_40x40.png',
    currency: {
        ore: 'images/layers/purple_ore.png',
        gold: 'images/layers/gold.png',
        ruby: 'images/layers/ruby.png',
        prestige: 'images/pick_40x40.png',
        depth: 'images/pick_40x40.png',
        upgrades: 'images/upgrades_40x40.png'
    },
    skill: {        
        missiles: 'images/missile_40x40.png',
        orbit: 'images/orbit_40x40.png',
        laser: 'images/laser_40x40.png',
        lightning: 'images/laser_40x40.png',
        chain: 'images/laser_40x40.png',
        drill: 'images/drill_40x40.png',
        radar: 'images/laser_40x40.png',
        fissure: 'images/laser_40x40.png',
        minions: 'images/laser_40x40.png',
        dynamite: 'images/dynamite_40x40.png',
        damage: 'images/laser_40x40.png',
        activation: 'images/laser_40x40.png',
    }
};